import React, { useRef, useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Form, Input, Button, Row, Col, Select, message } from 'antd';
import { AlphaNumInput, RegexInput } from 'shared_components/pattern_input';
//test
import { CustomContactNo } from 'components_test/contact_input';

//sample data
import data from './sampleData';
import { fetchCustomers, fetchCustomersName } from 'services/customers/customers';

import '../customer.css';
import { UserAccessContext } from 'context/userAccess';

const { Text } = Typography;
const { Option } = Select;

function SearchCustForm({ onFinish }) {
	const { userAccess } = useContext(UserAccessContext);
	const navigate = useHistory();
	const formRef = useRef();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	//sample data
	const [filterData, setFilterData] = useState(data);
	const [checkVal, setCheckVal] = useState('');
	const [customerNameList, setCustomerNameList] = useState([]);

	const createRight = userAccess['customersSetup'].create;

	useEffect(() => {
		async function fetchData() {
			const customerNames = await fetchCustomersName();

			setFilterData(data);
			setCustomerNameList(customerNames);
		}
		setLoading(true);
		fetchData();
		setLoading(false);
	}, []);

	async function handleSubmit(formValues) {
		const checkCust = formValues.cust_code;
		const checkCustName = formValues.cust_name;
		const checkStatus = formValues.cust_status;

		const payload = {
			customer_code: checkCust,
			customer_name: checkCustName,
			status: checkStatus,
		};
		// agent search api
		try {
			const result = await fetchCustomers(payload);

			setFilterData(result);
			onFinish(result);

			if (result.length <= 0) {
				message.info('No results found');
			}
		} catch (error) {
			console.log('error', error);
		}
	}

	function handleFocusCustomerCode() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		setFieldsValue({ cust_name: [], cust_status: [] });
	}

	function clearSearch() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		setFieldsValue({ cust_code: '', cust_status: [], cust_name: [] });
		setFilterData([]);
	}

	const customerNameOptions = customerNameList.map(data => (
		<Option key={data.customer_id} value={data.customer_name}>
			{data.customer}
		</Option>
	));

	return (
		<div>
			<Form
				layout="vertical"
				onFinish={handleSubmit}
				ref={formRef}
				form={form}
				className="form-search-customers"
			>
				<Row gutter={[8, 1]} align="bottom">
					{/* user fields */}
					<Col span={6} className="gutter-row">
						<Form.Item label="CUSTOMER CODE" name="cust_code">
							<AlphaNumInput 
								placeholder="CUSTOMER CODE"
								regex={/[A-Za-z0-9-]/}
                                onFocus={handleFocusCustomerCode}
                                maxLength={20}
                            />
						</Form.Item>
					</Col>
					<Col span={1}>
						{/* <div style={{ marginLeft:5 ,marginRight:10, marginTop:35 }}> */}
						<div style={{ marginBottom: 7 }}>
							<Text strong className="inv-filler-str">
								OR
							</Text>
						</div>
					</Col>
					<Col span={9} className="gutter-row">
						<Form.Item label="CUSTOMER NAME" name="cust_name">
							<Select
								placeholder="CUSTOMER NAME"
								showSearch
								allowClear
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
							>
								{customerNameOptions}
							</Select>
						</Form.Item>
					</Col>
					<Col span={8} className="gutter-row">
						<Form.Item label="STATUS" name="cust_status">
							<Select
								placeholder="STATUS"
								showSearch
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
							>
								<Option value="ACTIVE">ACTIVE</Option>
								<Option value="INACTIVE">INACTIVE</Option>
							</Select>
						</Form.Item>
					</Col>
					{/* buttons */}
				</Row>
				<Row gutter={[8, 1]} justify="end">
					<Col span={6}>
						<Form.Item shouldUpdate>
							{({ getFieldsValue }) => {
								const { cust_code, cust_name, cust_status } = getFieldsValue();
								const disabled = !(cust_code || cust_name || cust_status);

								return (
									<div style={{ float: 'right', marginBottom: '-5px' }}>
										<Button
											className="login-form-button inv-button"
											type="primary"
											htmlType="submit"
											disabled={disabled}
										>
											SEARCH
										</Button>
										<Button className="form-button inv-button-right" onClick={clearSearch}>
											CLEAR
										</Button>
									</div>
								);
							}}
						</Form.Item>
					</Col>
				</Row>
				{(createRight === 'TRUE')
				?	<Row gutter={[8, 1]} justify="end">
						<Col>
							<Form.Item>
								<Button
									className="login-form-button inv-button-right"
									type="primary"
									onClick={() => navigate.push('/customer/add_customer')}
								>
									ADD CUSTOMER
								</Button>
							</Form.Item>
						</Col>
					</Row>
				:	<></>
				}
			</Form>
		</div>
	);
}

export default SearchCustForm;
